import { html, TemplateResult } from 'lit';
import { ImpressionsList } from '../types/types.js';

/**
 * Render intro section with title and description
 * @param impressionsList - Impressions list object with title and intro text
 * @returns Lit template result
 */
export const renderIntro = (impressionsList: ImpressionsList): TemplateResult => {
    return html`
        <div class="der-tm-impressions__header">
            <der-ui-module-title
                title=${impressionsList.title}
                intro=${impressionsList.intro ?? ''}
                ?inverted=${false}
            ></der-ui-module-title>
        </div>
    `;
};
